import { render, staticRenderFns } from "./AlertDoubleAction.vue?vue&type=template&id=4b652de0&scoped=true"
import script from "./AlertDoubleAction.vue?vue&type=script&lang=js"
export * from "./AlertDoubleAction.vue?vue&type=script&lang=js"
import style0 from "./AlertDoubleAction.vue?vue&type=style&index=0&id=4b652de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b652de0",
  null
  
)

export default component.exports